import Header from './Header';
import NavigationDesktop from './Navigation/NavigationContainer';

import type { Configs } from '@shared/types/configs';
import type { UserContext } from '@shared/types/user-context';
import type { Stay } from '@shared/types/utils';
import type { Destination } from '@shared/ui/types';
import type { NavigationItems } from '@shared/utils-frontend/navigation-service';

import BpkBreakpoint, { BREAKPOINTS } from '@shared/ui/common/BpkBreakpoint';
import { withConfiguration } from '@shared/utils-frontend/contexts/ConfigurationContext';
import { withUserContext } from '@shared/utils-frontend/contexts/UserContext';

type Props = {
  backHref: string;
  items: NavigationItems;
  userContext: UserContext;
  configs: Configs;
  destination: Destination;
  stay: Stay;
};

const Navigation = ({
  backHref,
  configs,
  destination,
  items,
  stay,
  userContext,
  ...rest
}: Props) => (
  <BpkBreakpoint query={BREAKPOINTS.MOBILE}>
    {(isMobile: boolean) => {
      if (isMobile) {
        return (
          <Header
            backHref={backHref}
            destination={destination}
            stay={stay}
            {...rest}
            items={items.filter(({ mobile }) => mobile)}
          />
        );
      }
      return (
        <NavigationDesktop
          items={items}
          stay={stay}
          destination={destination}
          {...rest}
        />
      );
    }}
  </BpkBreakpoint>
);

export default withUserContext(withConfiguration(Navigation));
